// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"53c415aa","496":"e99446d7","706":"9146657a"}[chunkId] + ".chunk.js";
};